
import Vue from "vue";

export default Vue.extend({
  name: "ApiItemDetails",
  props: {
    entry: Object,
    itemDetails: Boolean
  }
});
